import React from "react";
import BackgroundImage from "../../../assets/background/login/image.png";

export default function Background({ children }) {
  return (
    <div
      className="relative w-full h-screen bg-cover bg-center"
      style={{ backgroundImage: `url(${BackgroundImage})` }}
    >
      {children}
    </div>
  );
}
